export const CREDITS_SLICE_NAME = "credits"
